import { ReactNode } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache, { StylisPlugin } from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { useConfig } from '../providers/ConfigProvider';

export type Direction = 'ltr' | 'rtl';

interface RTLLayoutProps {
  children: ReactNode;
}

export const RTLLayout = ({ children }: RTLLayoutProps) => {

  const direction: Direction = useConfig().direction;

  const cacheRtl = createCache({
    key: direction === 'rtl' ? 'rtl' : 'css',
    prepend: true,
    stylisPlugins: direction === 'rtl' ? [rtlPlugin as StylisPlugin] : []
  });

  return (
    <CacheProvider value={cacheRtl}>
      {children}
    </CacheProvider>
  );
}; 